import { IconProps } from '@/types/icon-props'

const ShoppingBag = ({ className }: IconProps) => {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M7.11537 21.5C6.65512 21.5 6.27083 21.3458 5.9625 21.0375C5.65417 20.7292 5.5 20.3449 5.5 19.8846V9.11538C5.5 8.65512 5.65417 8.27083 5.9625 7.9625C6.27083 7.65417 6.65512 7.5 7.11537 7.5H9V7C9 6.0282 9.34038 5.20192 10.0212 4.52115C10.7019 3.84038 11.5282 3.5 12.5 3.5C13.4718 3.5 14.2981 3.84038 14.9789 4.52115C15.6596 5.20192 16 6.0282 16 7V7.5H17.8846C18.3449 7.5 18.7292 7.65417 19.0375 7.9625C19.3458 8.27083 19.5 8.65512 19.5 9.11538V19.8846C19.5 20.3449 19.3458 20.7292 19.0375 21.0375C18.7292 21.3458 18.3449 21.5 17.8846 21.5H7.11537ZM7.11537 20.5H17.8846C18.0385 20.5 18.1795 20.4359 18.3077 20.3077C18.4359 20.1795 18.5 20.0385 18.5 19.8846V9.11538C18.5 8.96154 18.4359 8.82052 18.3077 8.6923C18.1795 8.5641 18.0385 8.5 17.8846 8.5H16V11C16 11.1423 15.9522 11.2612 15.8567 11.3567C15.7612 11.4522 15.6423 11.5 15.5 11.5C15.3577 11.5 15.2388 11.4522 15.1433 11.3567C15.0478 11.2612 15 11.1423 15 11V8.5H10V11C10 11.1423 9.95224 11.2612 9.85673 11.3567C9.76123 11.4522 9.64232 11.5 9.5 11.5C9.35768 11.5 9.23877 11.4522 9.14327 11.3567C9.04776 11.2612 9 11.1423 9 11V8.5H7.11537C6.96154 8.5 6.82052 8.5641 6.6923 8.6923C6.5641 8.82052 6.5 8.96154 6.5 9.11538V19.8846C6.5 20.0385 6.5641 20.1795 6.6923 20.3077C6.82052 20.4359 6.96154 20.5 7.11537 20.5ZM10 7.5H15V7C15 6.29615 14.7593 5.70353 14.2779 5.22213C13.7965 4.74071 13.2039 4.5 12.5 4.5C11.7962 4.5 11.2035 4.74071 10.7221 5.22213C10.2407 5.70353 10 6.29615 10 7V7.5Z"
        fill="currentColor"
      />
    </svg>
  )
}

export default ShoppingBag
